export default __webpack_public_path__ + "static/media/code1.70a00034.png";